/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {StatoSimulazioniWidget} from '../../../_metronic/partials/widgets'

export function StatoSimulazioni() {
  return (
    <>	
      <div className='col-xl-12'>
        <StatoSimulazioniWidget className='card-xxl-stretch mb-5 mb-xl-10' />
      </div>
    </>
  )
}
